import { PERMISSIONS, COMMON } from '../utils/constants.json';

const INITIAL_STATE = { userPermissions: [], permittedsolutions: [] };
/**
 * Reducer - to update services state
 * @param {Object} state initial/default services state.
 * @param {Object} action to be performed
 * @return {Object} new services state
 */
export default function (state = INITIAL_STATE, action) {
  const { payload } = action;
  switch (action.type) {
    case PERMISSIONS.SUCCESS:
      return {
        userPermissions: payload.permissions,
        permittedSolutions: payload.solutionType,
      };
    case PERMISSIONS.FAILURE:
      return INITIAL_STATE;
    case COMMON.CLEAR.LOGOUT_CLEAR:
      return INITIAL_STATE;
    default:
      return state;
  }
}
